import create from 'zustand'

export type CoverLetterMenu = 'SEARCH' | 'SCRAP' | 'DETAIL'

type coverLetterStoreType = {
  currentMenu: CoverLetterMenu
  setCurrentMenu: (menu?: CoverLetterMenu) => void

  coverLetterId?: string
  setCoverLetterId: (id?: string) => void
}

export const useCoverLetterStore = create<coverLetterStoreType>((set) => ({
  currentMenu: 'SEARCH',
  setCurrentMenu: (menu) => {
    set(() => ({
      currentMenu: menu,
    }))
  },

  coverLetterId: undefined,
  setCoverLetterId: (id) => {
    set((state) => ({
      ...state,
      coverLetterId: id,
    }))
  },
}))
